/*
saikrishna 10/06/2022 3075154998 Removed unecesarry console.log statements
dilip 10/11/2022 3075154998 Data Manager Matching logic changes
Suresh Peddavoora 10/26/2022 3075154998  Added Class Name for Text Fields and Buttons
Akhila  10/28/2022 3075154998 data manager ux changes
Guru Prasad  10/29/2022 3075154998 data manager Card styles UI changes
Suresh Peddavoora 10/31/2022 3075154998  Added styles for table header
Lalitha 11/01/2022 3075154998   changes disable(filter/filterGroup, PMF/PMFGroup)only one allow
Lalitha 11/9/2022  3075154998 Rename Button Cancel to Reset
*/
import React, {useEffect, useState, useContext} from 'react';
import {Formik} from 'formik';
import {Button, TextField, Typography, FormHelperText, Accordion, AccordionSummary, AccordionDetails} from '@material-ui/core';
import DialogBox from '../../../../../components/DialogBox';
import ConditionForm from './Condition/AddCondition';
import ConditionTable from './Condition/ConditionTable';
import {useDispatch, useSelector} from 'react-redux';
import {SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {
  postDmRecords,
  fetchFilterGroupDropdownData,
  fetchCodeDropdownData,
  resetStatus,
} from '../../../../../redux/reducers/EnableFramework/DmRecords';
import {getOptions} from '../../../../../util/GetDropDownOptions';
import {FIELD_SEPERATOR} from '../../../../../constants/Lookup';
import AddIcon from '@material-ui/icons/Add';
import {makeStyles} from '@material-ui/core/styles';
import {getFieldSeperator} from '../../../../../redux/reducers/LetterMaintainance/LetterCommunication';
import ActionForm from './Action/ActionForm';
import ActionTable from './Action/ActionTable';
import FilterGroupSystemNotes from './FilterGroupSystemNotes';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {ArrowBack} from '@material-ui/icons';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'margin': '10px 0px 0',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  detailsCard: {
    backgroundColor: '#fbfbfb',
  },
}));
const options = [
  {value: 'Yes', valueCode: 'Y'},
  {value: 'No', valueCode: 'N'},
];
const AddDmRecordsForm = ({
  setTabValue,
  filterCode,
  setFilterCode,
  setFilterCodeName,
  filterCodeName,
  isCopyRowData,
  setUsageState,
}) => {
  const classes1 = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);
  const {filterGroupData, filterData, successMsg, saveDmRecordStatus,
    DmRecordData} = useSelector(({DmRecords}) => DmRecords);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFieldSeperator());
    dispatch(fetchFilterGroupDropdownData());
    dispatch(fetchCodeDropdownData());
  }, []);
  const initialVal = {
    code: '',
    description: '',
    fixedLength: '',
    fieldSeparator: '',
    masterRecord: '',
    filterCode: '',
    filterGroupCode: '',
  };
  const {fieldSeperatorData} = useSelector(({commmunicaionLetter}) => commmunicaionLetter);
  const [filterOpen, setFilterOpen] = useState(false);
  const [recordData, setRecordData] = useState([]);
  const [isConditionEditMode, setIsConditionEditMode] = useState(false);
  const [reset, setReset] = useState(false);
  const [actionOpen, setActionOpen] = useState(false);
  const [initialValues, setInitialValues] = useState(initialVal);
  const [conditionRowData, setConditionRowData] = useState('');
  const [expanded, setExpanded] = useState();
  const [conditionCode, setConditionCode] = useState('');
  // const schema = Yup.object().shape({
  //   filterName: Yup.string()
  //     .required("Filter code is required")
  //     .matches(/^[a-zA-Z0-9]+$/, "White space and special character are not allowed"),
  //   description: Yup.string().required("Description is required"),
  // });
  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const getObj = (val, options) => {
    const value = options.filter((i) => i.valueCode === val);
    return value[0];
  };
  const getObjectDrop = (option, typeCode, dropDownData) => {
    const options = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.value === option) {
          label = item;
        }
      });
    return label;
  };

  useEffect(() => {
    if (Object.keys(DmRecordData).length > 0) {
      const newInitialValues = {
        fieldSeparator: DmRecordData?.fieldSeparator ?
          getObjectDrop(DmRecordData?.fieldSeparator, FIELD_SEPERATOR, fieldSeperatorData) :
          {},
        filterCode: DmRecordData?.filterCode,
        filterGroupCode: DmRecordData?.filterGroupCode,
        fixedLength: DmRecordData?.fixedLength ? getObj(DmRecordData?.fixedLength, options) : '',
        masterRecord: DmRecordData?.masterRecord ? getObj(DmRecordData?.masterRecord, options) : '',
        postFilter: DmRecordData?.postMatchFilter,
        postMatchFilterGroup: DmRecordData?.postMatchFilterGroup,
        recordCode: DmRecordData?.recordCode,
        recordId: DmRecordData?.recordId,
        description: DmRecordData?.description,
      };
      setInitialValues(newInitialValues);
    }
  }, [DmRecordData]);
  useEffect(() => {
    if (Object?.keys(DmRecordData)?.length > 0) {
      const data = [...DmRecordData?.dataManagerRecordFieldRequest];
      const newData = data.map((data) => {
        const conditionList = {
          ...data,
          description: data?.description ? data.description : '',
          displayFormat: data?.displayFormat ? data.displayFormat : '',
          endPosition: data?.endPosition ? data.endPosition : '',
          fieldName: data?.fieldName ? data.fieldName : '',
          fieldType: data?.fieldType ? data.fieldType : '',
          recordCode: data?.recordCode ? data.recordCode : '',
          recordFieldId: 0,
          startPosition: data?.startPosition ? data.startPosition : '',
          groupName: data?.groupName ? data.groupName : '',
          seqNum: data?.seqNum ? data.seqNum : '',
        };

        return conditionList;
      });
      setRecordData(newData);
    }
    // if (Object.keys(filterData).length > 0) {
    //   const data = [...filterData?.integrationFilterActions];
    //   const newActionData = data.map((i) => {
    //     return {
    //       ...i,
    //       description: i?.description ? i.description : "",
    //       expression: i?.expression ? i.expression : "",
    //       format: i?.format ? i.format : "",
    //       actionId: i?.actionId ? i?.actionId : 0,
    //       name: i?.fieldCode ? i.fieldCode : "",
    //       returnValueType: i?.returnType ? i.returnType : "",
    //       sourceField: i?.sourceField ? i.sourceField : "",
    //       toField: i?.toField ? i.toField : "",
    //       type: i?.type ? i.type : "",
    //       sequenceNo: i?.sequenceNo ? Number(i?.sequenceNo) : "",

    //       disposition: i?.disposition ? i.disposition : "",
    //     };
    //   });
    //   setActionData(newActionData);
    // }
  }, [filterData, reset]);
  useEffect(() => {
    if (saveDmRecordStatus === 200) {
      setTimeout(() => {
        setTabValue(0);
        dispatch(resetStatus());
      }, 2000);
    }
  }, [saveDmRecordStatus]);


  const handleConditionClose = () => {
    setFilterOpen(false);
    setIsConditionEditMode(false);
    // setRuleGroupSNo(conditionData?.length);
  };
  const handleActionCLose = () => {
    setActionOpen(false);
    // setIsEditMode(false);
    // dispatch(resettingFieldData());
  };

  // const handleDialogState = () => {
  //   setDialogState(false);
  // };

  const handleSubmit = (values) => {
    const records =
      recordData?.length > 0 ?
        recordData.map((data) => {
          const conditionAction = {
            description: data?.description ? data.description : '',
            displayFormat: data?.displayFormat ? data.displayFormat : '',
            endPosition: data?.endPosition ? data.endPosition : '',
            fieldName: data?.fieldName ? data.fieldName : '',
            fieldType: data?.fieldType ? data.fieldType : '',
            recordCode: data?.recordCode ? data.recordCode : '',
            recordFieldId: 0,
            startPosition: data?.startPosition ? data.startPosition : '',
            groupName: data?.groupName ? data.groupName : '',
            seqNum: data?.seqNum ? data.seqNum : '',
          };
          return conditionAction;
        }) :
        [];
    const postData = {
      description: values?.description ? values?.description : '',
      fieldSeparator: values?.fieldSeparator ? values?.fieldSeparator?.value : '',
      filterCode: values?.filter ? values?.filter?.filterCode : '',
      filterGroupCode: values?.filterGroup ? values?.filterGroup?.filterGroupCode : '',
      fixedLength: values?.fixedLength?.valueCode ? values.fixedLength.valueCode : '',
      masterRecord: values?.masterRecord ? values?.masterRecord?.valueCode : '',
      postMatchFilter: values?.postFilter ? values?.postFilter : '',
      postMatchFilterGroup: values?.postMatchFilterGroup ? values?.postMatchFilterGroup : '',
      recordCode: values?.recordCode ? values?.recordCode : '',
      recordId: values?.recordId ? values?.recordId : '',
      dataManagerRecordFieldRequest: records?.length > 0 ? records : [],
      deletedRecordFieldId: [],
    };
    // setOverRiding(postData);
    dispatch(postDmRecords(postData));
  };

  return (
    <div>
      <div className="button-table-spacing-mb justify-content-start">
        <Button
          variant="outlined"
          type="button"
          // disabled={isLoading || successMsg}
          disabled={successMsg}
          className={`search-btn mx-1 ${classes.buttonRoot}`}
          onClick={() => {
            setTabValue(0);
          }}

        >
          <ArrowBack className="mr-2" />
                    Search Records
        </Button>
      </div>
      <div>
        <Formik
          onSubmit={(values, {validate}) => {
            handleSubmit(values);
            validate(values);
          }}
          initialValues={initialValues}
          // validationSchema={schema}
          validateOnChange={true}
          validateOnBlur={false}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleSubmit,
              handleReset,
              handleBlur,
              setFieldValue,
              touched,
              errors,
              resetForm,
            } = props;

            return (
              <div className={`mb-0`}>
                <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                  <div className="form-row global-field-textfields">
                    <div className="col-sm-6 col-md-4  form-group">
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder="Enter Filter Code"
                        label="Record Code"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="recordCode"
                        value={values?.recordCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        required
                        touched={touched.code}
                        error={Boolean(touched.code && errors.code)}
                      />
                      {/* <FormHelperText style={{ color: "red" }}>
                        {touched.filterName && errors.filterName}
                      </FormHelperText> */}
                    </div>
                    <div className="col-sm-6 col-md-4  form-group">
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Description`}
                        label="Description"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        required
                        touched={touched.description}
                        error={Boolean(touched.description && errors.description)}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.description && errors.description}
                      </FormHelperText>
                    </div>

                    <div className={`col-sm-6 col-md-4  form-group ${classes.selectdropdown}`} >
                      <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        {...props}
                        id="filter"
                        options={filterData}
                        size="small"
                        autoHighlight
                        // disabled={values?.filterCode}
                        disabled={values?.filterGroup}
                        getOptionDisabled={(option) => option.filterCode === null}
                        getOptionLabel={(option) => {
                          return option && option?.filterCode && option?.filterName ?
                            option.filterCode + ' - ' + option.filterName :
                            option?.filterName === null ?
                              option?.filterCode :
                              '';
                        }}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('filter', value);
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            margin="dense"
                            {...params}
                            className={` ${classes.labelName} ${classes.selectLabel}`}
                            variant="outlined"
                            fullWidth
                            // disabled={values?.filterGroup}
                            placeholder={`Select Filter`}
                            label="Filter"
                            name="filter"
                            touched={touched.filter}
                            error={Boolean(touched.filter && errors.filter)}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        )}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.filter && errors.filter}
                      </FormHelperText>
                    </div>
                    <div className={`col-sm-6 col-md-4  form-group ${classes.selectdropdown}`}>
                      <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        {...props}
                        id="filterGroup"
                        options={filterGroupData?.length > 0 ? filterGroupData : []}
                        size="small"
                        autoHighlight
                        // disabled={values?.filterGroup}
                        disabled={values?.filter}
                        getOptionDisabled={(option) => option.filterGroupCode === null}
                        getOptionLabel={(option) => {
                          return option && option?.filterGroupCode && option?.filterGroupName ?
                            option.filterGroupCode + ' - ' + option.filterGroupName :
                            option?.filterGroupName === '' ?
                              option?.filterGroupCode :
                              '';
                        }}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('filterGroup', value);
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            margin="dense"
                            {...params}
                            className={` ${classes.labelName} ${classes.selectLabel}`}
                            variant="outlined"
                            fullWidth
                            // disabled={values?.filterGroupCode}
                            placeholder={`Select Filter`}
                            label="Filter Group"
                            name="filterGroup"
                            touched={touched.filterGroup}
                            error={Boolean(touched.filterGroup && errors.filterGroup)}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        )}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.filterGroup && errors.filterGroup}
                      </FormHelperText>
                    </div>
                    <div className={`col-sm-6 col-md-4 form-group ${classes.selectdropdown}`}>
                      <GuiAutoComplete
                        classes={{
                        // popper: classes.popper,
                          option: classes.option,
                        }}
                        // {...props}
                        id="fixedLength"
                        options={options}
                        value={values?.fixedLength}
                        size="small"
                        autoHighlight
                        getOptionDisabled={(option) => option.valueCode === null}
                        renderOption={(option) => option.valueCode + ' - ' + option.value}
                        getOptionLabel={(option) => {
                          return option && option.valueCode;
                        }}
                        onChange={(e, data) => {
                        // props.onChange(data);
                          handleChange(e);
                          setFieldValue('fixedLength', data);
                        // setFixLength(data?.valueCode !== "Y");
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            margin="dense"
                            {...params}
                            className={` ${classes.labelName} ${classes.selectLabel}`}
                            variant="outlined"
                            fullWidth
                            label="Fixed Length"
                            name="fixedLength"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            placeholder="Select Fixed Length"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        )}
                      />
                    </div>
                    <div className={`col-sm-6 col-md-4  form-group ${classes.selectdropdown}`}>
                      <GuiAutoComplete
                        classes={{popper: classes.popper, option: classes.option}}
                        {...props}
                        id="fieldSeperator"
                        options={getOptions(FIELD_SEPERATOR, fieldSeperatorData)}
                        size="small"
                        value={values?.fieldSeparator}
                        getOptionDisabled={(option) => option.valueCode === null}
                        autoHighlight
                        getOptionLabel={(option) => {
                          return option && option.value ? option.value : '';
                        }}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('fieldSeperator', value);
                        }}
                        disabled={values?.fixedLength?.value === 'Yes'}
                        renderInput={(params) => (
                          <GuiTextField
                            className={` ${classes.labelName} ${classes.selectLabel}`}
                            {...params}
                            variant="outlined"
                            fullWidth
                            required
                            label="Field Seperator"
                            name="fieldSeperator"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            placeholder="Select Field Seperator"
                            error={Boolean(errors.fieldSeperator?.message)}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        )}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.description && errors.description}
                      </FormHelperText>
                    </div>
                    <div className={`col-sm-6 col-md-4  form-group`}>
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Post Match Filter`}
                        label="Post Match Filter"
                        disabled={values?.postMatchFilterGroup}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="postFilter"
                        value={values?.postFilter}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.filterGroup}
                        error={Boolean(touched.filterGroup && errors.filterGroup)}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.filterGroup && errors.filterGroup}
                      </FormHelperText>
                    </div>
                    <div className={`col-sm-6 col-md-4  form-group`}>
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Post Match Filter Group`}
                        label="Post Match Filter Group"
                        disabled={values?.postFilter}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="postMatchFilterGroup"
                        value={values.postMatchFilterGroup}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      // touched={touched.filterGroup}
                      // error={Boolean(touched.filterGroup && errors.filterGroup)}
                      />
                      {/* <FormHelperText style={{ color: "red" }}>
                        {touched.filterGroup && errors.filterGroup}
                      </FormHelperText> */}
                    </div>
                    <div className={`col-sm-6 col-md-4  form-group ${classes.selectdropdown}`}>
                      <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        {...props}
                        id="masterRecord"
                        value={values?.masterRecord}
                        options={options}
                        size="small"
                        autoHighlight
                        getOptionDisabled={(option) => option.valueCode === null}
                        renderOption={(option) => option.valueCode + ' - ' + option.value}
                        getOptionLabel={(option) => {
                          return option && option.valueCode;
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            margin="dense"
                            {...params}
                            className={` ${classes.labelName} ${classes.selectLabel}`}
                            variant="outlined"
                            fullWidth
                            label="Master Record"
                            name="masterRecord"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            placeholder="Select Master Record"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        )}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('masterRecord', value);
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    {values?.fixedLength?.valueCode === 'Y' ?
                      <div className={`border-rounded mb-4`}>
                        <div className="table-header table-card-header  d-flex justify-content-between">
                          <Typography variant="h3"> Fixed Length Records </Typography>
                          <Button
                            variant="outlined"
                            className={`search-btn ${classes.buttonRoot}`}
                            onClick={() => {
                              setFilterOpen(true);
                            }}
                          >
                            <AddIcon />
                            Add
                          </Button>
                        </div>
                        <ConditionTable
                          setRecordData={setRecordData}
                          recordData={recordData}
                          // conditionData={conditionData}
                          // setConditionData={setConditionData}
                          setIsConditionEditMode={setIsConditionEditMode}
                          setConditionRowData={setConditionRowData}
                          setConditionCode={setConditionCode}
                        // setDeleteCondition={setDeleteCondition}
                        // deleteCondition={deleteCondition}
                        // ruleGroupSNo={ruleGroupSNo}
                        />
                      </div> :
                      <div className={`border-rounded mb-3 px-2`}>
                        <div className="table-header table-card-header d-flex justify-content-between">
                          <Typography variant="h3">Variable Length Records </Typography>
                          <Button
                            variant="outlined"
                            className={`search-btn ${classes.buttonRoot}`}
                            onClick={() => setActionOpen(true)}
                          >
                            <AddIcon />
                            Add
                          </Button>
                        </div>
                        <ActionTable
                        // actionData={actionData}
                        // setActionData={setActionData}
                        // setActionRowData={setActionRowData}
                        // setIsEditMode={setIsEditMode}
                        // setActionCode={setActionCode}
                        // setDeleteAction={setDeleteAction}
                        // deleteAction={deleteAction}
                        />
                      </div>
                    }
                  </div>
                  <div className="button-spacing-mb">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`reset-btn mx-1 ${classes.buttonRoot}`}
                      onClick={() => {
                        if (!filterCode) {
                        // setActionData([]);
                        // setConditionData([]);
                          resetForm();
                        } else {
                          resetForm();
                          setReset(!reset);
                        }
                      }}
                    >
                    Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                    >
                    Save
                    </Button>
                  </div>
                </form>
                {DmRecordData?.recordCode && (
                  <div className={`${classes1.root} mt-3`}>
                    <Accordion
                      className="accordion-styling"
                      expanded={expanded === 'panel1'}
                      onChange={handleAccordionChange('panel1')}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMore sx={{fontSize: '0.9rem'}} />}
                        aria-controls="panel1d-content"
                        id="panel1d-header"
                      >
                        <Typography className={classes1.heading}>
                   Record Notes
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails className={classes1.detailsCard}>
                        <FilterGroupSystemNotes filterGroupCode={DmRecordData?.recordCode} />
                      </AccordionDetails>
                    </Accordion>
                  </div>
                )}
              </div>
            );
          }}
        </Formik>
        <DialogBox
          open={filterOpen || isConditionEditMode}
          dialogClose={handleConditionClose}
          title={filterOpen ? 'Add Record' : isConditionEditMode ? 'Edit Record' : ''}
          maxWidth="md"
        >
          <ConditionForm
            setRecordData={setRecordData}
            recordData={recordData}
            // setConditionData={setConditionData}
            // conditionData={conditionData}
            setFilterOpen={setFilterOpen}
            // handleConditionClose={handleConditionClose}
            conditionRowData={conditionRowData}
            isConditionEditMode={isConditionEditMode}
            setIsConditionEditMode={setIsConditionEditMode}
            conditionCode={conditionCode}
          // ruleGroupSNo={ruleGroupSNo}
          />
        </DialogBox>
        <DialogBox
          open={actionOpen}
          dialogClose={handleActionCLose}
          title={actionOpen ? 'Add Record' : ''}
          maxWidth="md"
        >
          <ActionForm
            // setActionData={setActionData}
            // actionData={actionData}
            // setActionOpen={setActionOpen}
            // handleActionCLose={handleActionCLose}
            // actionRowData={actionRowData}
            // isEditMode={isEditMode}
            // setIsEditMode={setIsEditMode}
            // actionCode={actionCode}
            // setParameter={setParameter}
          />
        </DialogBox>
        {/* {isLoading && <PageLoader />} */}
        {/* {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />} */}
        {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      </div>
    </div>
  );
};

export default AddDmRecordsForm;
